import { render } from "./ArticleList.vue?vue&type=template&id=2acaf32e&ts=true"
import script from "./ArticleList.vue?vue&type=script&lang=ts"
export * from "./ArticleList.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__